<template>  
  <div class="main clearfix">
    <div class="picture">
      <!-- 为ECharts准备一个具备大小（宽高）的Dom -->
      <div id="useTrendPicture" :style="{width: '100%', height: '350px'}"></div>
    </div>
  </div>
</template>

<script>
  import * as powerControl from "../../../../../static/js/powerControl.js"
  import * as date from "../../../../../static/js/date.js"
  import { deviceApi } from "../../../../../static/js/api.js"
  import { showToast } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'UseTrendList',
    data() {
      return {
        useTrendType:'YEAR',
        xAxisData:[],
        yAxisData:[],
        trendName:'',
      }
    },
    mounted:async function() {
      this.getEmeterYearMonthDay()
    },
    created() {
    },
    methods: {
      async getEmeterYearMonthDay(){
        let that = this
        this.xAxisData=[]
        this.yAxisData=[]
        const dataObj ={
          'dateType': that.useTrendType
        }
        let res = await deviceApi.getEmeterYearMonthDay(dataObj);
        if(res.meta.code == '200'){
          for(let i in res.data.list){
            let str =''
            if(that.useTrendType == 'YEAR'){
              that.trendName = '本年用电量'
              str = i+'月'
            }else if(that.useTrendType == 'MONTH'){
              that.trendName = '本月用电量'
              str = i+'日'
            }else{
              that.trendName = '今日用电量'
              str = i+'时'
            }
            that.xAxisData.push(str)
            that.yAxisData.push(res.data.list[i])
          }
          this.drawLine(this.xAxisData,this.yAxisData);
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      // echarts画图函数
      drawLine(xAxisData,yAxisData){
        let that = this;
        this.$nextTick(function(){
          // 基于准备好的dom，初始化echarts实例
          let myChart = this.$echarts.init(document.getElementById('useTrendPicture'))
          // 绘制图表

          let option = {
            title : {
              text: that.trendName,
              x:'center'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            xAxis: [
              {
                type: 'category',
                data: xAxisData,
                axisPointer: {
                  type: 'shadow'
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                // name: '本年用电量',
                // name:that.trendName,
                axisLabel: {
                  formatter: '{value} KWH'
                }
              }
            ],
            series: [
              {
                name:'用电量',
                type:'bar',
                data:yAxisData,
                color:['#5c75f3']
              }
            ]
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
        })
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.useTrendType":async function(newVal, oldVal) {
        this.xAxisData = [];
        this.yAxisData = [];
        this.useTrendType = newVal;
        this.getEmeterYearMonthDay()
      },

    },
    props: []
  }
</script>

<style lang="scss" scoped>
.main {
  width:100%;
  height: 100%;
  border:0.1px solid white;
}
.top10List {
  width:500px;
  height:30px;
  border:1px solid black;
  margin: 10px;
}
.eMeterName {
  margin-top: 15px;
  margin-left: 10px;
  float: left;
}
.eMeterValue {
  color: red;
  margin-top: 15px;
  margin-left: 10px;
  margin-right: 10px;
  float: right;
}
.picture {
  width:100%;
  height:100%;
}
.clearfix::after {
  content: ''; 
  display: block; 
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CEnergyManage/BuildingInfo/UseTrendList.vue